var brandInfoAll={
  bannerInfo:{
    bannerNmae:"乐白机器人",
    createTime:"2017年",
    area:"中国 上海",
    honor:[
      'CE认证'
    ]
  },
  subsidiary:[
    {
      name:"上海",
      langname:"上海（总公司）",
      address:"上海市徐汇区宜山路889号",
      corporateName:"上海乐白机器人有限公司"
    },
  ],
  certify:[
     
  ],

  otherProductsAdvantages:{
    productsTitle:"/static/brand/zhitong/tedian/title.png",
    aboutTitleWidth:"849px",
    textTitle:"以精粹之作服务大众生活",
    textList:[
      '乐白机器人凭借轻型易用、安全可靠、通用协作等特点，已经广泛应用于轻工业、餐饮业、医疗、教育、生活服务等多个行业领域。乐白目前正在与酒店及民生行业接洽，建立协作机器人创新应用合作；联合集成行业伙伴，为客户提供一站式智能化产线解决方案。',
    ],
    textImg:"/static/brand/lebai/youshi/product.png",
    height:"215px",
    list:[
      {
        titleImg:"/static/brand/lebai/tedian/1.png",
        infoList:[
          'LM3 支持场景和动作样式设置。提供语音、灯光、硬件按钮操作等多种人机交互方式，提升了机器人易用性及应用效率。',
        ],
        title:"交互个性化"
      },
      {
        titleImg:"/static/brand/lebai/tedian/2.png",
        infoList:[
          '无需示教器，乐白机器人采用牵引/拖动示教，通过Web浏览器或APP即可方便操作机器人。乐白团队自主创新研发的时间轴编辑器，提供低门槛场景编辑体验。',
        ],
        title:"简洁易用" 
      },
      {
        titleImg:"/static/brand/lebai/tedian/3.png",
        infoList:[
          '乐白机器人支持丰富的控制协议接口，便于联动和快速支持外部系统和设备，也可以更好地控制第三方扩展I/O设备。',
        ],
        title:"高扩展性" 
      },
      {
        titleImg:"/static/brand/lebai/tedian/4.png",
        infoList:[
          'LM3 机器人本体与控制箱总重低于14kg，轻量化的机身在使用、安装、部署上都更为便捷。',
        ],
        title:"轻量化机身" 
      },
      {
        titleImg:"/static/brand/lebai/tedian/5.png",
        infoList:[
          'LM3 所有关节均可实现无运动范围限制的旋转，为机器人应用场景提供了更多可能性。',
        ],
        title:"关节无限制" 
      },
      {
        titleImg:"/static/brand/lebai/tedian/6.png",
        infoList:[
          'LM3 支持碰撞安全防护，当检测到物体碰撞时，机器人立即停止/暂停，对周围的人/物提供及时有效的安全保证。',
        ],
        title:"安全有保障"
      }
    ]


  },
  pindustry:{
      industryTitleImg:"/static/brand/qingneng/hangye/industryTitleImg.png",
      list:[
        {
          bjimg:"/static/brand/lebai/hangye/5.png",
          title:"水吧",
        },
        {
          bjimg:"/static/brand/lebai/hangye/6.png",
          title:"送餐",
        },
        {
          bjimg:"/static/brand/lebai/hangye/7.png",
          title:"无人咖啡店",
        },
        {
          bjimg:"/static/brand/lebai/hangye/10.png",
          title:"装配",
        },
        {
          bjimg:"/static/brand/lebai/hangye/8.png",
          title:"煮面",
        },
        {
          bjimg:"/static/brand/lebai/hangye/9.png",
          title:"注塑下料",
        },

        {
          bjimg:"/static/brand/lebai/hangye/1.png",
          title:"冰淇淋",
        },
        {
          bjimg:"/static/brand/lebai/hangye/2.png",
          title:"餐盘餐盒上料",
        },
        {
          bjimg:"/static/brand/lebai/hangye/3.png",
          title:"煎蛋",
        },
        {
          bjimg:"/static/brand/lebai/hangye/4.png",
          title:"奶茶",
        },
        
        
        
        
        
        
      ]    
    },
  bigimg:"/static/brand/zhitong/bigimg/big.png",
  
  aboutus:
  {
        info:"上海乐白机器人有限公司成立于2017年，是创新的协作机器人产品及解决方案提供商。由一批深耕机器人、机器视觉、互联网软件等领域多年的跨专业人士发起和成立的科技型企业。 乐白致力于生活和服务领域的机器人及机器人附件的设计、研发、生产和销售。网络化、云端化的机器人软件平台以及乐白生态链体系将面向商业应用、智能家庭生活等场景，提供基于软硬件一体化的订阅制服务解决方案，为各端用户创造更大价值。",
        video:"https://image.sjyuan.net.cn/video/mvb/lebai.mp4",
        poster:"/static/brand/lebai/guanyu/video.png",
        aboutTitle:"/static/brand/lebai/guanyu/top.png",
        aboutTitleWidth:"355px"
  },
  
  metaInfo:{
    title:"乐白机器人_Movibot品牌_协作机器人",
    keywords:"协作机器人_工业机器人_智慧家庭_商业应用_乐白机器人",
    description:"乐白机器人是协作机器人产品及解决方案提供商,致力于生活和服务领域的机器人的设计、研发、生产和销售。MOVIBOT为您提供该品牌及产品介绍，丰富的产品选型，让您更快速准确的找到所需商品。",
  }
  


}
export default {
  brandInfoAll
};


// WEBPACK FOOTER //
// ./src/data/brand/5.js